import React, {useEffect, useState} from 'react';

type ReportItem = {
    ID: number;
    title: string;
    post_date: string;
    pdf_files: string[];
};

type ReportListProps = {
    categorySlug: string;
    heading: string;
    onSelect: (report: { title: string; date: string; pdfSrc: string }) => void;
};

const ReportList: React.FC<ReportListProps> = ({categorySlug, heading, onSelect}) => {
    const [reports, setReports] = useState<ReportItem[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const baseUrl: string = process.env.REACT_APP_WORDPRESS_API as string;
        const url = `${baseUrl}?category=${encodeURIComponent(categorySlug)}`;

        fetch(url)
            .then(res => res.json())
            .then((data: ReportItem[]) => {
                const sorted = data.sort((a, b) =>
                    new Date(b.post_date).getTime() - new Date(a.post_date).getTime()
                );
                setReports(sorted);
            })
            .catch(err => {
                console.error(`Fetch failed for URL: ${url}. Error details:`, err);
                setError("Failed to load reports. Please try again later.");
            });
    }, [categorySlug]);

    if (error) {
        return (
            <div style={{fontWeight: 'bold', padding: '20px'}}>
                ❗Oops! We ran into a problem while loading the reports.<br/>
                Please try again in a moment.
            </div>
        );
    }

    return (
        <div className='news-post-list'>
            <h3>
                <div></div>
            </h3>
            <div className='report-heading'>
                {heading}
            </div>
            {reports.map((report) => (
                <div className='news-post' key={report.ID}>
                    {report.pdf_files.length > 0 && (
                        <button
                            onClick={() => onSelect({
                                title: report.title,
                                date: report.post_date,
                                pdfSrc: report.pdf_files[0],
                            })}
                            style={{all: 'unset', cursor: 'pointer', display: 'block', width: '100%'}}
                        >
                            <div className='report-post-title'>
                                {report.title}
                            </div>
                        </button>
                    )}
                    {report.pdf_files.length === 0 && (
                        <div className='report-post-title' style={{color: '#999'}}>
                            {report.title} (No PDF)
                        </div>
                    )}
                    <span className='news-post-date' style={{marginBottom: '5px'}}>{report.post_date}</span>
                    <hr style={{marginTop: '10px', marginBottom: '0px'}}/>
                </div>
            ))}
        </div>
    );
};

export default ReportList;
